
import React from "react";
import { Check } from "lucide-react";
import { motion } from "framer-motion";

interface LeftPanelProps {
  communityName: string;
}

export const LeftPanel: React.FC<LeftPanelProps> = ({ communityName }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="space-y-8"
    >
      <div className="space-y-6">
        <h2 className="text-4xl lg:text-5xl font-bold text-foreground leading-tight">
          Welcome to
          <br />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80">
            {communityName}
          </span>
        </h2>
      </div>
      
      <div className="space-y-6">
        <div className="flex items-start">
          <div className="flex-shrink-0 mt-0.5">
            <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
              <Check className="h-4 w-4 text-primary-foreground" />
            </div>
          </div>
          <div className="ml-4">
            <p className="text-base">Join our thriving community and connect with neighbors who share your interests</p>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="flex-shrink-0 mt-0.5">
            <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
              <Check className="h-4 w-4 text-primary-foreground" />
            </div>
          </div>
          <div className="ml-4">
            <p className="text-base">Discover local businesses and service providers with special community discounts</p>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="flex-shrink-0 mt-0.5">
            <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
              <Check className="h-4 w-4 text-primary-foreground" />
            </div>
          </div>
          <div className="ml-4">
            <p className="text-base">Stay informed about community events, news, and special promotions</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
